// extracted by mini-css-extract-plugin
export default {"container":"MismatchConfirmationDialog_container__68Trr"};